import { CurrencySchema } from '@eigtech/currency';
import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
import { BillSchema } from '../base/index.js';
export const ReportBillPaymentMadeApiSchema = {
    params: z.object({
        entityId: CornSchema,
        billId: z.string(),
    }),
    body: z.object({
        amountPaid: CurrencySchema,
        paymentDate: z.string().datetime(),
    }),
    headers: z.object({ requestActor: z.string() }),
    response: z.object({ bill: BillSchema.optional() }),
};
export const ReportBillPaymentMadeInternalApiSchema = {
    params: z.object({
        billId: z.string(),
    }),
    body: z.object({
        amountPaid: CurrencySchema,
        paymentDate: z.string().datetime(),
    }),
    response: z.object({ bill: BillSchema.optional() }),
};
export const ReportBillPaymentMadePathSchema = ReportBillPaymentMadeApiSchema.params;
export const ReportBillPaymentMadeInternalRequestSchema = ReportBillPaymentMadeInternalApiSchema.params.merge(ReportBillPaymentMadeInternalApiSchema.body);
export const ReportBillPaymentMadeRequestSchema = ReportBillPaymentMadeApiSchema.params
    .merge(ReportBillPaymentMadeApiSchema.headers)
    .merge(ReportBillPaymentMadeApiSchema.body);
export const ReportBillPaymentMadeResponseSchema = ReportBillPaymentMadeApiSchema.response;
